import { palette } from "lib/miolo";
import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import getYear from "date-fns/getYear";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";
import numeral from "numeral";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import EmployeeIcon from "components/svg/UserIcon";
import { FormattedMessage } from "react-intl";

interface EmployeesCountCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment | IAmericanCompanyIssuerTopLevelFragment;
}

export default function EmployeesCountCard({ issuer }: EmployeesCountCardProps) {
  if (!issuer.employeeNumbers) {
    return null;
  }

  return (
    <div>
      <IconCard primaryColor={palette.fiord} secondaryColor={palette.catskillWhite} icon={<EmployeeIcon />}>
        <CardValue>{numeral(issuer.employeeNumbers.totalOfEmployees).format("0,0").replace(",", ".")}</CardValue>
        <CardDescription>
          <FormattedMessage
            defaultMessage="N° de Empregados • {asOfYear}"
            id="wkv1qi"
            description="Employees count card"
            values={{
              asOfYear: getYear(parseDateYmd(issuer.employeeNumbers.asOfDate)),
            }}
          />
        </CardDescription>
      </IconCard>
    </div>
  );
}
